"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API Key Management API
 * API for managing verifying email addresses on the Socrata platform.  # Signing Up On The Socrata Platform  When a user signs up for the platform, an email containing a token will be sent to the address they signed up with.  New users will not be able to login to the platform or be added as a collaborator on any assets until they first click the link that was emailed to them.  # Changing Emails  When a user wants to change their email address, they can do so if they also provide their current password.  When this is done, an email will be sent to the new email address that contains a token.  An email will also be sent to the user\'s old account letting them know that their email has changed on the platform. This is to protect users whose accounts may have been compromised to let them know of malicious email change attempts. In this case, they can contact Socrata support to reclaim the account if needed.  The email change will be pending and the user will still have their old email address until they click the link that was emailed to their new account. When this link is clicked, the email change is applied.  # Changelog  ## 1.1.0  Change generator enum property naming to `original` for `typescript-fetch` client.  Add missing error codes.  ## 1.0.0  Initial specification.
 *
 * The version of the OpenAPI document: 1.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorResponseCodeEnum = exports.ErrorResponseToJSON = exports.ErrorResponseFromJSONTyped = exports.ErrorResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ErrorResponseFromJSON(json) {
    return ErrorResponseFromJSONTyped(json, false);
}
exports.ErrorResponseFromJSON = ErrorResponseFromJSON;
function ErrorResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['code'] === 'USER_VERIFICATION.CANNOT_CHECK_OTHERS_STATUS') {
            return _1.ErrorResponseCannotCheckOthersStatusFromJSONTyped(json, true);
        }
        if (json['code'] === 'USER_VERIFICATION.EMAIL_NOT_VALID') {
            return _1.ErrorResponseEmailNotValidFromJSONTyped(json, true);
        }
        if (json['code'] === 'USER_VERIFICATION.INVALID_TOKEN') {
            return _1.ErrorResponseInvalidTokenFromJSONTyped(json, true);
        }
        if (json['code'] === 'USER_VERIFICATION.NO_CURRENT_STATUS') {
            return _1.ErrorResponseNoCurrentStatusFromJSONTyped(json, true);
        }
        if (json['code'] === 'USER_VERIFICATION.NO_PENDING_EMAIL_CHANGE') {
            return _1.ErrorResponseNoPendingEmailChangeFromJSONTyped(json, true);
        }
        if (json['code'] === 'USER_VERIFICATION.PENDING_EMAIL_CHANGE_ALREADY_EXISTS') {
            return _1.PendingEmailChangeAlreadyExistsFromJSONTyped(json, true);
        }
        if (json['code'] === 'USER_VERIFICATION.PENDING_EMAIL_VERIFICATION_ALREADY_EXISTS') {
            return _1.PendingEmailVerificationAlreadyExistsFromJSONTyped(json, true);
        }
        if (json['code'] === 'USER_VERIFICATION.TOKEN_EXPIRED') {
            return _1.ErrorResponseTokenExpiredFromJSONTyped(json, true);
        }
        if (json['code'] === 'USER_VERIFICATION.EMAIL_VERIFICATION_REQUIRED') {
            return _1.ErrorResponseEmailVerificationRequiredFromJSONTyped(json, true);
        }
        if (json['code'] === 'USER.EMAIL_CHANGE_PENDING') {
            return _1.ErrorResponseEmailChangePendingFromJSONTyped(json, true);
        }
        if (json['code'] === 'AUTHENTICATION.LOCKED_OUT') {
            return _1.ErrorResponseLockedOutFromJSONTyped(json, true);
        }
        if (json['code'] === 'AUTHENTICATION.INCORRECT_PASSWORD') {
            return _1.ErrorResponseIncorrectPasswordFromJSONTyped(json, true);
        }
        if (json['code'] === 'AUTHENTICATION.SSO_MANAGED_ACCOUNT') {
            return _1.ErrorResponseSsoManagedAccountFromJSONTyped(json, true);
        }
    }
    return {
        'error': !runtime_1.exists(json, 'error') ? undefined : json['error'],
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
        'code': !runtime_1.exists(json, 'code') ? undefined : json['code'],
    };
}
exports.ErrorResponseFromJSONTyped = ErrorResponseFromJSONTyped;
function ErrorResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'error': value.error,
        'message': value.message,
        'code': value.code,
    };
}
exports.ErrorResponseToJSON = ErrorResponseToJSON;
/**
* @export
* @enum {string}
*/
var ErrorResponseCodeEnum;
(function (ErrorResponseCodeEnum) {
    ErrorResponseCodeEnum["USER_VERIFICATION_CANNOT_CHECK_OTHERS_STATUS"] = "USER_VERIFICATION.CANNOT_CHECK_OTHERS_STATUS";
    ErrorResponseCodeEnum["USER_VERIFICATION_EMAIL_NOT_VALID"] = "USER_VERIFICATION.EMAIL_NOT_VALID";
    ErrorResponseCodeEnum["USER_VERIFICATION_INVALID_TOKEN"] = "USER_VERIFICATION.INVALID_TOKEN";
    ErrorResponseCodeEnum["USER_VERIFICATION_NO_CURRENT_STATUS"] = "USER_VERIFICATION.NO_CURRENT_STATUS";
    ErrorResponseCodeEnum["USER_VERIFICATION_NO_PENDING_EMAIL_CHANGE"] = "USER_VERIFICATION.NO_PENDING_EMAIL_CHANGE";
    ErrorResponseCodeEnum["USER_VERIFICATION_PENDING_EMAIL_CHANGE_ALREADY_EXISTS"] = "USER_VERIFICATION.PENDING_EMAIL_CHANGE_ALREADY_EXISTS";
    ErrorResponseCodeEnum["USER_VERIFICATION_PENDING_EMAIL_VERIFICATION_ALREADY_EXISTS"] = "USER_VERIFICATION.PENDING_EMAIL_VERIFICATION_ALREADY_EXISTS";
    ErrorResponseCodeEnum["USER_VERIFICATION_TOKEN_EXPIRED"] = "USER_VERIFICATION.TOKEN_EXPIRED";
    ErrorResponseCodeEnum["USER_VERIFICATION_EMAIL_VERIFICATION_REQUIRED"] = "USER_VERIFICATION.EMAIL_VERIFICATION_REQUIRED";
    ErrorResponseCodeEnum["USER_EMAIL_CHANGE_PENDING"] = "USER.EMAIL_CHANGE_PENDING";
    ErrorResponseCodeEnum["AUTHENTICATION_LOCKED_OUT"] = "AUTHENTICATION.LOCKED_OUT";
    ErrorResponseCodeEnum["AUTHENTICATION_INCORRECT_PASSWORD"] = "AUTHENTICATION.INCORRECT_PASSWORD";
    ErrorResponseCodeEnum["AUTHENTICATION_SSO_MANAGED_ACCOUNT"] = "AUTHENTICATION.SSO_MANAGED_ACCOUNT";
})(ErrorResponseCodeEnum = exports.ErrorResponseCodeEnum || (exports.ErrorResponseCodeEnum = {}));
